module.exports = __webpack_public_path__ + "img/other_al.e3f264a6.svg";